import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";
import { BookOpen } from "@styled-icons/feather/BookOpen";
import { FileText } from "@styled-icons/feather/FileText";
import { Video } from "@styled-icons/feather/Video";
import { Download } from "@styled-icons/feather/Download";

interface MaterialButtonProps {
  variant?: 'primary' | 'warning' | 'danger' | 'success';
}


export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr{
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary{
    background-color: #05367f;
    display: block;
    border: 0px;
    width: 100%;
  }

  .card {
    margin: 15px 0px;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;

  .pull-right{
    position: relative;
    float: right;
  }
`;


export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

// Componentes para cards de materiais no estilo das atividades
export const MaterialCard = styled.div`
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
  overflow: hidden;
  position: relative;
  min-height: 380px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #007bc6, #0056b3, #28a745);
  }
`;

export const MaterialHeader = styled.div`
  padding: 20px 15px 15px;
  text-align: center;
  position: relative;
  flex-shrink: 0;
`;

export const MaterialContent = styled.div`
  padding: 0 15px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const MaterialIcon = styled.div`
  width: 60px;
  min-width: 60px;
  height: 60px;
  min-height: 60px;
  margin: 0 auto 15px;
  background: linear-gradient(135deg, #007bc6 0%, #0056b3 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(0, 123, 198, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 123, 198, 0.4);
  }
`;

export const MaterialBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  
  &.pdf {
    background: linear-gradient(135deg, #dc3545, #c82333);
    color: white;
  }
  
  &.video {
    background: linear-gradient(135deg, #6f42c1, #5a32a3);
    color: white;
  }
  
  &.texto {
    background: linear-gradient(135deg, #007bff, #0056b3);
    color: white;
  }
  
  &.material {
    background: linear-gradient(135deg, #28a745, #1e7e34);
    color: white;
  }
  
  &.default {
    background: linear-gradient(135deg, #28a745, #1e7e34);
    color: white;
  }
`;

export const MaterialTitle = styled.div`
  display: block;
  width: 100%;
  position: relative;
  min-height: 45px;
  overflow: hidden;
  padding: 8px 0px;
  font-size: 14px;
  line-height: 1.3;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
`;

export const MaterialDescription = styled.div`
  color: #6c757d;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 15px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
`;

export const MaterialActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  margin-top: auto;
  padding: 0 5px;
`;

export const MaterialButton = styled.button<MaterialButtonProps>`
  background: ${props => {
    if (props.variant === 'primary') return 'linear-gradient(135deg, #007bff, #0056b3)';
    if (props.variant === 'warning') return 'linear-gradient(135deg, #ffc107, #e0a800)';
    if (props.variant === 'danger') return 'linear-gradient(135deg, #dc3545, #c82333)';
    return 'linear-gradient(135deg, #28a745, #1e7e34)';
  }};
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 18px;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  margin: 2px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 18px rgba(0, 0, 0, 0.3);
    color: white;
    text-decoration: none;
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  }
`;

export const TopButton = styled.div`
  position: absolute;
  right: 20px;
  top: 10px;
  z-index: 9;
  cursor: pointer;
`;

// Ícones específicos para materiais
export const BookOpenIcon = styled(BookOpen)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const FileTextIcon = styled(FileText)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const VideoIcon = styled(Video)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const DownloadIcon = styled(Download)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 8px;
`;

export const PageHeader = styled.div`
  background: #fff;
  padding: 20px;
  margin: -15px -15px 20px -15px;
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #495057;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  
  &::before {
    content: '\f02d';
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    font-size: 20px;
    color: #007bff;
  }
`;

export const HeaderStats = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  color: #6c757d;
  font-size: 14px;
`;

export const StatNumber = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #007bff;
`;

export const StatLabel = styled.span`
  font-size: 12px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SearchContainer = styled.div`
  width: 100%;
  
  .form-group {
    width: 100%;
    margin-bottom: 0;
  }
  
  .input-group {
    width: 100%;
  }
`;

export const SearchGroup = styled.div`
  position: relative;
  margin-bottom: 20px;
  
  .form-group {
    margin-bottom: 0;
  }
  
  .dropdown-container {
    position: relative;
  }
`;

export const SearchInput = styled.input`
  background: white;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  flex: 1;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
  
  &::placeholder {
    color: #6c757d;
  }
`;

export const SearchButton = styled.button`
  background: #007bff;
  color: white;
  border: 1px solid #007bff;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: calc(1.5em + 1rem + 2px);
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background: #0056b3;
    border-color: #0056b3;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const ClearButton = styled.button`
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:hover {
    background: #545b62;
  }
`;

export const SearchDropdown = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const DropdownItem = styled.li`
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f8f9fa;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f8f9fa;
  }
  
  &:last-child {
    border-bottom: none;
  }
  
  &.highlighted {
    background-color: #e3f2fd;
  }
`;

export const AddButton = styled.button`
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    background: linear-gradient(135deg, #0056b3, #004085);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const ActiveFilterContainer = styled.div`
  margin-top: 15px;
  padding: 10px 0;
  border-top: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  animation: slideIn 0.3s ease-out;
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ActiveFilterBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
  animation: fadeIn 0.3s ease;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const FilterLabel = styled.span`
  font-size: 12px;
  color: #6c757d;
  margin-right: 8px;
  font-weight: 500;
`;

export const ClearFilterButton = styled.button`
  background: none;
  border: none;
  color: white;
  padding: 2px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:focus {
    outline: none;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const FilterColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

